import React from "react";
import { Navigate } from "react-router-dom";
import Loader from "../common/Loader";
import { useAuthGuard } from "src/hooks/useAuthGuard";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { status, redirectTo } = useAuthGuard();

  if (status === "loading") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader size="lg" />
      </div>
    );
  }

  if (redirectTo && status !== "success") {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
